/**
 * Bonbon More Module
 * 初期4件表示 + もっと見るで残り表示
 */
export class BonbonMore {
  constructor() {
    this.root = document.querySelector('.p-bonbon-more');
    if (!this.root) {
      return;
    }

    this.list = this.root.querySelector('.p-bonbon-more__list');
    this.items = this.root.querySelectorAll('.p-bonbon-more__item');
    this.button = this.root.querySelector('.p-bonbon-more__button');

    if (!this.list || !this.button) {
      return;
    }

    this.visibleCount = 4;
    this.init();
  }

  init() {
    if (this.items.length <= this.visibleCount) {
      this.button.style.display = 'none';
      return;
    }

    this.button.addEventListener('click', () => {
      this.expand();
    });
  }

  expand() {
    this.root.classList.add('is-open');
    this.button.style.display = 'none';
  }
}
